export const RESELLER_IDS = {
  LYON_WAUGH_AUTO_GROUP: '422',
  MOSS_AUTO_GROUP: '447',
  NAPLETON_AUTO_GROUP: '441',
  PHIL_LONG: '127',
  PENSKE_AUTOMOTIVE: '81',
};
